module.exports = __webpack_public_path__ + "img/已归档.f315fdfe.png";